import { Card, Flex, Typography } from 'antd';
import React from 'react';
import { Heading } from '../Heading';
import {
  CustomerServiceIcon,
  DeliveryBoxIcon,
  ExchangeIcon,
  MegaPhoneIcon,
  TLStatusIcon,
} from '../Icons';
import { formatDateByDayjs } from '@/utils';
import { NotificationTabEnum } from '../Header/NotificationDrawer';
import { generatePath, useNavigate } from 'react-router-dom';
import { ROUTE } from '@/config';

const { Text } = Typography;

interface NotifCardProps {
  title?: string;
  iconColor: string;
  description?: string;
  createdAt: string;
  isSeen?: boolean;
  type: NotificationTabEnum;
  selectedTab: NotificationTabEnum;
  itemUid: string;
  closeModal: () => void;
}

const NotificationCard: React.FC<NotifCardProps> = ({
  title,
  iconColor,
  description,
  createdAt,
  type,
  selectedTab,
  isSeen,
  itemUid,
  closeModal,
}) => {
  const navigate = useNavigate();

  const getIconByType = () => {
    if (type === NotificationTabEnum.All) return null;
    const TypeIcons = {
      [NotificationTabEnum.ORDERS]: DeliveryBoxIcon,
      [NotificationTabEnum.ANNOUNCEMENT]: MegaPhoneIcon,
      [NotificationTabEnum.REMITTANCE]: ExchangeIcon,
      [NotificationTabEnum.SUPPORT]: CustomerServiceIcon,
    };

    const IconByType = TypeIcons[type];
    return (
      <div className='w-8 min-w-8 h-8 bg-customGrayShade2 rounded-full flex items-center justify-center'>
        <IconByType width={16} height={16} color='#939496' />
      </div>
    );
  };

  const handleRedirect = () => {
    let path =
      type === NotificationTabEnum.ORDERS
        ? `${ROUTE.ORDER_DETAILS}/${itemUid}`
        : generatePath(ROUTE.FINANCE_DETAILS, { id: itemUid });

    switch (type) {
      case NotificationTabEnum.ORDERS:
        path = `${ROUTE.ORDER_DETAILS}/${itemUid}`;
        break;
      case NotificationTabEnum.REMITTANCE:
        path = generatePath(ROUTE.FINANCE_DETAILS, { id: itemUid });
        break;
      case NotificationTabEnum.SUPPORT:
        path = generatePath(ROUTE.TICKET_CENTER_DETAILS, { id: itemUid });
        break;
      default:
        break;
    }

    navigate(path);
    closeModal();
  };

  const isCardLink = [
    NotificationTabEnum.ORDERS,
    NotificationTabEnum.REMITTANCE,
    NotificationTabEnum.SUPPORT,
  ].includes(type);
  return (
    <Card
      className={`px-1 ${isCardLink ? 'cursor-pointer' : ''}`}
      styles={{ body: { padding: '1rem' } }}
      onClick={isCardLink ? handleRedirect : undefined}
    >
      <Flex gap='0.5rem'>
        {selectedTab === NotificationTabEnum.All ? getIconByType() : null}
        <Flex vertical className='w-full'>
          <Flex className=' flex justify-between items-start mb-2'>
            <Heading
              title={title}
              fontWeight='font-semibold'
              fontSize='text-xs'
              extraClassName='leading-[18px] w-full'
            />
            <Flex className='flex items-center gap-x-1'>
              <Text className='font-normal text-xs leading-[18px] text-customGrayShade5 min-w-20 text-end mt-[1px]'>
                {formatDateByDayjs(createdAt, 'DD MMM, YYYY')}
              </Text>
              {!isSeen && <TLStatusIcon color={iconColor} />}
            </Flex>
          </Flex>
          <Flex className='flex items-center w-[298px]'>
            <Text
              className='font-normal text-sm leading-[20px] text-customTunaPrimary w-full truncate'
              ellipsis
            >
              {description}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
};

export default NotificationCard;
